export enum LangCodes {
    GB = 'en-GB',
    US = 'en-US',
}
